module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-cul-4d5176dbbd9f7c9cf96154627ef199ab.png";